import { Rendition } from '@/types/api/media';
import { Money } from '@/types/util';
import { formatMoney } from '@/utils/Utils';

type OrderItemProps = { name: string; quantity: number; id: string; price: Money; thumbnail?: Rendition };

export default function OrderItem({ quantity, price, name, thumbnail }: OrderItemProps) {
  return (
    <li className="flex items-center py-2 border-b border-gray-200 dark:border-gray-700/60">
      <img
        className="block mr-2 xl:mr-4 shrink-0 w-16 xl:w-20"
        src={thumbnail?.url}
        width="200"
        height="142"
        alt={''}
      />
      <div className="w-full">
        <div className="grow">
          <h4 className="text-sm font-medium text-gray-800 dark:text-gray-100 leading-tight">{name}</h4>
        </div>
        <div className="flex justify-between">
          <div className="text-sm font-medium text-gray-600 dark:text-gray-100">{quantity} st</div>
          <div className="text-sm font-medium text-gray-600 dark:text-gray-100">{formatMoney(price!)}</div>
        </div>
      </div>
    </li>
  );
}
